const validate = values => {
  const errors = {}

  // Communication title
  if (!values?.communicationTitle) {
    errors.communicationTitle = "The communication title is required"
  }

  // Notification type
  if (!values?.notificationType) {
    errors.notificationType = "The notification type is required"
  }

  // Subject
  if (!values?.subject) {
    errors.subject = "The subject is required"
  }

  // Message
  if (!values?.message) {
    errors.message = "The message is required"
  }

  if (
    values?.webLink &&
    !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      values.webLink
    )
  ) {
    errors.webLink = "Invalid Link"
  }

  // Audience
  if (!values?.audience) {
    errors.audience =
      "You must check one option and select at least one experience/user/tag if you have selected one of the 3 checkboxes"
  } else if (
    values?.audience === "Individual users" &&
    (!values?.userSearch || values?.userSearch?.length === 0)
  ) {
    errors.userSearch = "Required"
  } else if (
    values?.audience === "Users in specific experiences" &&
    (!values?.experienceSearch || values?.experienceSearch?.length === 0)
  ) {
    errors.experienceSearch = "Required"
  } else if (
    values?.audience === "By tags" &&
    (!values?.tagSearch || values?.tagSearch?.length === 0)
  ) {
    errors.tagSearch = "Required"
  }

  //Scheduled send
  //time
  if (values?.date && !values?.time) {
    errors.time = "The time is required if you selected the date"
  }

  //timezone
  if (values?.date && !values?.timeZone) {
    errors.timeZone = "The timezone is required"
  }

  return errors
}

export default validate
